import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';
import type { BulkCreateJobFromRepositoryResponseDto } from 'app/API';

export const mapCreatedJobToAnalysisFile = (
  job: BulkCreateJobFromRepositoryResponseDto,
  analysisExtra: Record<string, unknown> | undefined,
): TFileWithMeta => ({
  meta: {
    id: job.id,
    name: job.name,
    status: 'external',
    extra: { jobId: job.id, mediaId: job.createdMedia.id, ...analysisExtra },
  },
});
